import styles from './Logo.module.css';
import { ReactComponent as LogoSvg } from '@Assets/svg/WiBro_logo.svg';

interface LogoProps {
	className?: string;
	onClick: () => void;
}

const Logo = (props: LogoProps) => {
	return (
		<div className={`${props.className} ${styles.logo}`} onClick={props.onClick}>
			<LogoSvg width="100%" height="100%" />
		</div>
	);
};

export default Logo;
